import React, { useEffect, useState } from 'react'
import { FOOTER } from '../footer/footer'
import { NAVAR } from '../navbar/navbar'
import fondo from "../../images/aviso.png";
import fondo2 from "../../images/aviso2.png";
import "./style.css";

export const NOTICES_FRICO = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 720);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 720);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
        <NAVAR></NAVAR>
        <div className='aviso-fc-mayo'>
            <img src={isMobile ? fondo2 : fondo} alt="Aviso" />
        </div>
        <FOOTER></FOOTER>
    </>
  )
}
